// src/data/personalInfo.js

export const personalInfo = {
  // Información básica
  name: "Gabriel",
  title: "Fotografo Audiovisual",
  subtitle:
    "Bajo el concepto Visión Nativa, desarrollo una práctica visual que entrelaza fotografía, cine documental y memoria. Mi enfoque busca registrar lo íntimo, lo cotidiano y lo ancestral, rescatando relatos locales y vínculos con el paisaje.",

  // Descripción personal
  bio: "Mi trabajo nace de una mirada arraigada al territorio que habito. Crecí observando los cerros que hoy siguen siendo parte de mi horizonte cotidiano. Desde esa primera imagen —una fotografía a mi familia con el cerro de fondo— entendí que mirar era también pertenecer.",

  // Información de contacto
  contact: {
    email: "g.asenie.urra@gmail.com",
    Behance: "/gasenieurra",
    Instagram: "@chilechicano",
    location: "Chile Chico, Región de Aysén - Chile",
  },

  // Enlaces a redes sociales
  social: {
    github: "https://www.instagram.com/chilechicano",
    linkedin: "https://www.behance.net/gasenieurra",
    email: "mailto:g.asenie.urra@gmail.com",
    twitter: "https://www.instagram.com/chilechicano", // opcional
  },

  // Habilidades por categorías
  skills: {
    Fotografia: {
      title: "Fotografía",
      description: "Captura fotográfica digital y análoga",
      technologies: ["Canon EOS R6", "Nikon D850", "Película 35mm", "Hasselblad", "Drones"],
    },
    Edicion: {
      title: "Edición y Post-Producción",
      description: "Procesamiento y revelado digital",
      technologies: ["Lightroom Classic", "Photoshop", "Capture One", "Premiere Pro"],
    },
    Video: {
      title: "Cine Documental",
      description: "Producción audiovisual y narrativa",
      technologies: ["Cámara Cinema", "DaVinci Resolve", "Dirección", "Edición de Video"],
    },
  },

  // Experiencia profesional (opcional)
  experience: [
    {
      title: "Fotógrafo Documental Independiente",
      company: "Visión Nativa",
      period: "2020 - Presente",
      description: "Desarrollo de proyectos fotográficos y audiovisuales sobre identidad, territorio y memoria en la Patagonia chilena.",
    },
  ],

  // Educación (opcional)
  education: [
    {
      degree: "Fotografía y Cine Documental",
      institution: "Formación Autodidacta",
      year: "2015 - Presente",
      description: "Aprendizaje continuo en fotografía, narrativa visual y producción audiovisual.",
    },
  ],

  // Configuración del sitio
  siteConfig: {
    title: "Gabriel Asenie Urra - Fotógrafo Audiovisual",
    description: "Portfolio de Gabriel Asenie Urra - Fotógrafo y cineasta documental en la Patagonia chilena. Visión Nativa.",
    url: "https://gasenieurra.com",
    image: "/og-image.jpg", // para redes sociales
  },
};

// Información adicional que puedes usar
export const navigation = [
  { id: "home", label: "Inicio" },
  { id: "about", label: "Sobre Mí" },
  { id: "projects", label: "Proyectos" },
];

// Textos de secciones
export const sectionTexts = {
  hero: {
    greeting: "Hola, soy",
    cta: {
      primary: "Ver Proyectos",
      secondary: "Contacto",
    },
  },
  about: {
    title: "Mi Mirada",
    subtitle:
      "Trabajo con comunidades, familias y espacios que me invitan a mirar desde adentro. Creo en una imagen viva, con raíz y contexto. Una imagen que escuche.",
  },
  projects: {
    title: "Proyectos Fotográficos",
    subtitle:
      "Registro visual que entrelaza identidad, territorio y memoria en la Patagonia",
  },
  contact: {
    title: "¿Colaboramos?",
    subtitle: "Estoy siempre interesado en nuevos proyectos fotográficos y audiovisuales",
    cta: "Enviar Mensaje",
  },
};

export default personalInfo;
